import React, { useState } from 'react'
import { useEffectOnce } from 'react-use'
import classnames from 'classnames'

import { getRole } from '../../../global/blocs/roomInfo'
import useFeatures from '../../../sharedLegacy/hooks/useFeatures'
import { useIsSpeakerGuest } from '../../../sharedLegacy/hooks/useSpeakersQuery'
import { useIsExternalFeedConnection } from '../../../global/blocs/useConnectInfo'

import * as Controls from './Controls'

import './HeadsUpDisplay.scss'

export const HeadsUpDisplay = () => {
  const [isOpen, setIsOpen] = useState(true)
  const {
    HasWebinarHighlightsEnabled,
    HasLiveTranscriptionsEnabled,
    HasWebinarFocusModeEnabled,
  } = useFeatures()

  useEffectOnce(() => {
    const timer = setTimeout(() => {
      setIsOpen(false)
    }, 4e3)
    return () => clearTimeout(timer)
  })

  const isSpeakerGuest = useIsSpeakerGuest()
  const isExternalStream = useIsExternalFeedConnection()

  return (
    <div className={classnames({ hud: true, open: isOpen })}>
      <div className="hud-controls">
        <div className="hud-controls-group">
          {HasWebinarHighlightsEnabled && getRole() === 'producer' && (
            <Controls.Highlight />
          )}
          {HasLiveTranscriptionsEnabled && (
            <Controls.LiveTranscriptionsToggle />
          )}
          {HasWebinarFocusModeEnabled && !isSpeakerGuest && <Controls.Focus />}
          {isExternalStream ? (
            <Controls.StreamingDetails />
          ) : (
            <>
              <Controls.Camera />
              <Controls.Microphone />
              <Controls.ScreenShare />
              <Controls.SecondCam />
              <Controls.ChangeDevices />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
